module.exports = __webpack_public_path__ + "img/img95_2.10240f5c.png";